module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-22.ded35592.png";